import { normalizeTenantId, tenantIdsEqual } from '@/lib/tenantUtils';

/**
 * Procure clients whose Contract Intelligence / Displacement / Benchmarking
 * tabs show only that tenant's closed_deals — never tenant_id = global (or null/empty).
 * Live Radar and Recently expired stay on the shared market feed.
 */
const OWN_CLOSED_DEALS_INSIGHT_TENANTS = new Set(['smowl', 'feedbackfruits_v2']);

export function usesOwnClosedDealsForInsights(tenantId) {
  const n = String(normalizeTenantId(tenantId) ?? '').trim().toLowerCase();
  return OWN_CLOSED_DEALS_INSIGHT_TENANTS.has(n);
}

/** Strict tenant match — excludes global, null, empty, and other tenants. */
export function dealInTenantInsights(deal, tenantId) {
  if (!deal || !tenantId) return false;
  const id = deal.tenant_id;
  if (id == null || id === '' || String(id).trim().toLowerCase() === 'global') return false;
  return tenantIdsEqual(id, tenantId);
}

/**
 * For insight-tab tenants, keep only own closed_deals.
 * Other tenants keep the mixed global + tenant corpus unchanged.
 */
export function filterClosedDealsToTenantInsights(deals, tenantId) {
  const list = Array.isArray(deals) ? deals : [];
  if (!usesOwnClosedDealsForInsights(tenantId)) return list;
  return list.filter((d) => dealInTenantInsights(d, tenantId));
}

/**
 * closed_deals.is_visible is TRI-STATE: false hides, true shows, and NULL/undefined SHOW.
 * Rows predating the column, and any insert path that does not set it, are real deals.
 * `=== true` and `Boolean(...)` both drop them — use `!== false` and nothing else.
 */
export function isDealVisible(deal) {
  return deal?.is_visible !== false;
}

export function filterVisibleDeals(deals) {
  return (Array.isArray(deals) ? deals : []).filter(isDealVisible);
}
